import React from 'react';
import { connect } from 'react-redux';
import * as actions from "../../../../store/actions";
import TablaCheques from './TablaCheques';

const TablaChequesRechazados = (props) => {
  const { cheques, loading, estaCargado } = props;

  const data = () => {
    let listaCheques = estaCargado ? cheques : [];

    return listaCheques && listaCheques.map((cheque) => {
      return {
        valor: cheque.valor,
        nroCheque: cheque.nroCheque,
        orden: cheque.orden,
        importe: cheque.importe && cheque.importe.toFixed(2),        
        vencimiento: cheque.vencimiento,      
        estado: cheque.estado,      
        banco: cheque.banco,      
        cliente: cheque.clienteId,      
        razonSocial: cheque.razonSocial,      
        tenedor: cheque.tenedor,
      };
    });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <TablaCheques 
        data={data()} 
        loading={loading} 
        maxHeight={props.maxHeight}
        minHeight={props.minHeight}
        onFiltersClick={() => props.onShowFiltersModal()}
        tituloTabla={"Tabla Cheques Rechazados" }
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cheques: state.cheques.listaChequesRechazados.cheques,
    loading: state.cheques.listaChequesRechazados.loading,
    estaCargado: state.cheques.listaChequesRechazados.estaCargado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Cheques rechazados', ['chequesRechazados']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablaChequesRechazados);